import React from "react";
import StartButton from "./StartButton";

const Hero = () => {
    return (
    <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "80vh", marginBottom: "90px"}}>
        <div className="text-center p-4">
            <h1 className="opacity-fade-in-1" style={{fontWeight: 400}}>It's time to <strong>level up</strong> your game</h1>
            <p className="opacity-fade-in-2">Unlock your full potential in Melee</p>
            <p className="opacity-fade-in-2">with top player guidance and comprehensive tutorials</p>
            {/* <iframe
                src="https://matthewpopa.github.io/press-start/"
                style={{ width: "500px", height: "170px", border: "none" }}
                title="3D Animation"
            /> */}
            <StartButton />
        </div>
    </div>
    );
};

export default Hero;